import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { Base } from "../../framework/base";
import { ISettingsMainStateProps, ISettingsMainOwnProps, ISettingsMainDispatchProps, SettingsMain } from "../../components/settings/settingsMain";
import { IEmployeeParameters } from "../../models/employee/employeeIParameters";

export function mapStateToProps(applicationState: IApplicationState): ISettingsMainStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.workMain)) {
        return {
            owner: null,
            user: null
        };
    }
    return {
        owner: applicationState.owner,
        user: applicationState.user
    };
}

export function mapDispatchToProps(dispatch: storeEffects.SettingsThunkDispatch): ISettingsMainDispatchProps {
    return {
        setEmployeeParameters: (parameters: IEmployeeParameters, saveToDb: boolean) => dispatch(storeEffects.setEmployeeParameters(parameters, saveToDb)),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<ISettingsMainStateProps, ISettingsMainDispatchProps, ISettingsMainOwnProps>(mapStateToProps, mapDispatchToProps)(SettingsMain);
